export const ERROR_UNKNOWN = 'error.AnUnknownErrorOccured';
export const LABEL_ACTIONS = 'label.Actions';
export const LABEL_MARKETPLACE = 'label.Marketplace';
export const MESSAGE_DELETE_CONFIRM = 'message.DeleteItemConfirm';
